// extracted by mini-css-extract-plugin
export default {"wrapper":"tableNav_wrapper__EY+WI","statusFilterBox":"tableNav_statusFilterBox__6GMCv","active":"tableNav_active__XDRGM"};